import { render, staticRenderFns } from "./WhatsappMessagePreview.vue?vue&type=template&id=0dc788d3&scoped=true"
import script from "./WhatsappMessagePreview.vue?vue&type=script&lang=js"
export * from "./WhatsappMessagePreview.vue?vue&type=script&lang=js"
import style0 from "./WhatsappMessagePreview.vue?vue&type=style&index=0&id=0dc788d3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc788d3",
  null
  
)

export default component.exports